export default __webpack_public_path__ + "static/media/atl.0d238164.svg";